module.exports = __webpack_public_path__ + "static/juno-logo-75577ea152ed64858664411d56c21330.png";